"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfilesController = function () {
  function ProfilesController(ProfilesService, FilterService, AppContextService, AuthService, $scope) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, ProfilesController);
    this.profilesService = ProfilesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.appContextService = AppContextService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";

    this.onFlagChanged = function (dataItem) {
      var appContext = _this.appContextService.getAppContext();
      dataItem.reviewedBy = appContext.userName;
      dataItem.dirty = true;
    };
  }

  (0, _createClass3.default)(ProfilesController, [{
    key: "$onInit",
    value: function $onInit() {
      this.profileReviewStatusOptions = {
        dataSource: [{ value: 2, text: "In Progress" }, { value: 0, text: "Approved" }],
        dataTextField: "text",
        dataValueField: "value"
      };
    }
  }, {
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this2 = this;

      return {
        dataSource: this.profilesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        height: "90vh",
        noRecords: {
          template: "No match found. Change your filter criteria."
        },
        columns: [{
          field: "fullName", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "4rem",
          template: function template(dataItem) {
            return "<a class=\"cell\" target=\"_blank\" href=\"/users/" + dataItem.userId + "\"><div class=\"image-container\"><img src=\"" + (dataItem.imageUrl ? _this2.imageBaseUrl + dataItem.imageUrl : "/images/user-image-unavailable.png") + "\"></img></div><span>" + dataItem.fullName + "</span></a>";
          }
        }, { field: "entityTypeName", title: "Account Type", filterable: false, attributes: { class: "col-account-type" }, width: "8rem" },
        // { field: "creationDate", title: "Signup Date", template: `<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>`, filterable: false, width: "8rem" },
        { field: "requiredReviewsText", title: "Required Reviews", filterable: false, width: "12rem" }, { field: "flaggedForReview", title: "Status", filterable: false, sortable: true, width: "2rem", template: function template(dataItem) {
            return "" + _this2._getProfileReviewStatus(dataItem.flaggedForReview);
          } },
        // { field: "country", title: "Country", filterable: false, width: "6rem" },
        { field: "reviewedBy", title: "Reviewed By", filterable: false, width: "2rem" }, { title: "Update", command: [{ name: "edit", text: "Update" }], width: "2rem" }],
        editable: {
          mode: "popup",
          window: { title: "Update Review Status" },
          template: kendo.template($("#popup-editor").html())
        }
      };
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.usersMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this3 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this3.applyFilters();
        }).catch(function (error) {
          _this3.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }, {
    key: "_getProfileReviewStatus",
    value: function _getProfileReviewStatus(status) {

      switch (status) {
        case _constants2.default.profileReviewStatus.REQUIRED:
          return "Required";
        case _constants2.default.profileReviewStatus.IN_PROGRESS:
          return "In Progress";
        default:
        case _constants2.default.profileReviewStatus.APPROVED:
          return "Approved";
      }
    }
  }]);
  return ProfilesController;
}();

exports.default = ProfilesController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/profiles/profiles.controller.js
 **/